module.exports = __webpack_public_path__ + "static/media/pig-green.9c7dc683.svg";